import { Attributes } from '@leverege/ui-attributes';
import Groupings from "../../groupings/Groupings.js";
import FilterUtil from "./FilterUtil.js";
/**
 * Returns the aggs options to attach to a search request.
 */
function getAggOptions(grouping, objectType) {
  const agg = {};
  let found = false;
  grouping.sections?.forEach(section => {
    const {
      id,
      attributeName
    } = section;
    const {
      filter,
      values
    } = section;
    const attr = Attributes.getAttribute(attributeName, objectType);
    const bp = attr?.blueprint;
    const field = bp?.field;
    let fieldType = null;
    if (bp?.attribute.type === 'parentRelationship') {
      fieldType = 'keyword';
    } else {
      fieldType = bp?.attribute?.searchType || 'string';
    }
    if (field) {
      found = true;
      agg[id] = FilterUtil.terms(field, fieldType);

      // Add the Section Filter.
      if (filter) {
        agg[id] = {
          type: 'filter',
          filter,
          aggs: {
            filteredAggs: agg[id]
          }
        };
      }
      values?.forEach(v => {
        // If the value has a filter or it is a missing / all type, we'll make a
        // filter request for the data. In the case of most type, the term aggregate
        // should get the data needed. 
        if (v.filter || Groupings.isMissing(v.value)) {
          const vFilter = FilterUtil.toFilter(v, field, fieldType, objectType);
          if (vFilter) {
            agg[`${v.value}@${id}`] = {
              type: 'filter',
              filter: vFilter
            };
          }
        }
      });
    }
  });
  return found ? agg : null;
}
function processAggResults(grouping, objectType, results) {
  const rtn = {};
  Object.entries(results.aggs).forEach(([key, agg]) => {
    const atIdx = key.lastIndexOf('@');
    if (atIdx > 0) {
      const vid = key.substring(0, atIdx);
      const id = key.substring(atIdx + 1);
      rtn[id] = rtn[id] || {};
      rtn[id][vid] = agg.count;
    } else {
      let buckets = agg.buckets;
      let total = results.count;
      if (agg.filteredAggs) {
        buckets = agg.filteredAggs.buckets;
        total = agg.count;
      }
      if (Array.isArray(buckets)) {
        rtn[key] = rtn[key] || {};
        rtn[key][Groupings.ALL_SECTION_VALUE] = total;
        buckets.forEach(c => {
          if (rtn[key][c.key] == null) {
            rtn[key][c.key] = c.count;
          }
        });
      }
    }
  });
  return rtn;
}
function sortValues(a, b) {
  const as = a.sort;
  const bs = b.sort;
  if (typeof as === 'number') {
    if (typeof bs === 'number') {
      return as - bs;
    }
    return -1;
  }
  if (typeof as === 'string') {
    if (typeof bs === 'number') {
      return 1;
    }
    if (typeof bs === 'string') {
      return as.localeCompare(bs);
    }
  }
  return 0;
}

/**
 * This will look for relationship value sources on the grouping
 * template and return an array of [ <prefix>/<path> ]. If none are
 * found, this return null
 */
function findRelationshipPaths(grouping, prefix) {
  const tmp = grouping.template;
  if (tmp == null) {
    return null;
  }
  if (Array.isArray(tmp.sections)) {
    const rtn = [];
    const s = tmp.sections;
    const add = v => {
      if (v.type === 'relationship') {
        rtn.push(`${prefix}/${v.path}`);
      }
    };
    for (let n = 0; n < s.length; n++) {
      if (Array.isArray(s[n].values)) {
        s[n].values.forEach(add);
      }
    }
    return rtn.length === 0 ? null : rtn;
  }
  return null;
}
export default {
  FILTER_NAME: 'molten.ImagineGroupingFilter',
  getAggOptions,
  processAggResults,
  combine: FilterUtil.combine,
  terms: FilterUtil.terms,
  doesNotExist: FilterUtil.doesNotExist,
  sortValues,
  findRelationshipPaths
};